import Vue from "vue";
import VueI18n, {LocaleMessages} from "vue-i18n";
import dateTimeFormats from "./config/date.json";
import numberFormats from "./config/currency.json";

Vue.use(VueI18n);

/**
 * load locales and set messages for views
 * @returns {Object}
 */
export function loadLocaleMessages() {
    const locales = require.context("./locales", true, /[A-Za-z0-9-]+\.json$/i);
    const messages: LocaleMessages = {};
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-]+)\./i);
        /* istanbul ignore next */
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key);
        }
    });
    return messages;
}

/**
 * @returns {VueI18n}
 */
export function createI18n() {
    return new VueI18n({
        locale: /* istanbul ignore next */(typeof process !== "undefined" ? process.env.VUE_APP_I18N_LOCALE : "de-DE") || "de-DE",
        fallbackLocale: /* istanbul ignore next */(typeof process !== "undefined" ? process.env.VUE_APP_I18N_FALLBACK_LOCALE : "en-US") || "en-US",
        dateTimeFormats,
        numberFormats,
        messages: loadLocaleMessages()
    });
}
